import styled from "styled-components";
import { Divider, Drawer, Radio } from "antd";

export const Container = styled(Drawer)`
  .ant-drawer-body {
    padding: 24px 0px 10px 0px;
  }

  .rowLabel {
    margin-bottom: 7px;
    margin-top: 19px;
  }

  .drawerForm {
    width: 100%;
    padding: 0px 24px;
    min-height: -moz-calc(100vh - 165px);
    min-height: -webkit-calc(100vh - 165px);
    min-height: calc(100vh - 165px);
  }

  label {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    margin-left: 15px;
    &:first-child {
      margin-top: 5px;
    }
    &.error {
      color: #d44c4c;
    }
  }

  .ant-row.rowInput {
    margin-top: 6px;
  }

  .tableButtonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      display: flex;
      justify-content: center !important;
      text-align: center !important;
      align-items: center !important;
      font-size: 14px !important;
      width: 77px !important;
      height: 30px !important;

      svg {
        margin-right: 3px !important;
      }
    }

    button:first-of-type {
      width: 116px !important;
      margin-right: 12px !important;
    }
  }

  .ant-switch-checked {
    background-color: #a9c133 !important;
  }
`;

export const ModalTitle = styled.span`
  font-size: 25px;
  font-family: "Asap", sans-serif;
  font-weight: bold;
  color: #4b4b4b;
`;

export const ButtonInputNumber = styled.button`
  background: transparent;
  color: #fff;
  border: none;
  width: 100% !important;
  height: 100% !important;

  &:hover {
    cursor: pointer;
  }

  svg {
    margin-left: 5px;
  }
`;

export const CustomDivider = styled(Divider)`
  margin: 10px 0 !important;

  .ant-divider-horizontal.ant-divider-with-text-center,
  .ant-divider-horizontal.ant-divider-with-text-left,
  .ant-divider-horizontal.ant-divider-with-text-right {
    margin: 10px 0 !important;
  }

  &.ant-divider-dashed {
    border-color: #e8e5e5 !important;
  }
  &.ant-divider-with-text-center::before,
  &.ant-divider-with-text-left::before,
  &.ant-divider-with-text-right::before,
  &.ant-divider-with-text-center::after,
  &.ant-divider-with-text-left::after,
  &.ant-divider-with-text-right::after {
    border-top: 1px dashed #e8e5e5 !important;
  }
  .ant-divider-inner-text {
    font-family: Asap;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
    color: #a5a5a5;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid #e8e8e8;
  margin-top: 20px;
  width: 100%;
  padding: 10px 24px;
  border-radius: 0 0 4px 4px;

  .buttonsDiv {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /* padding-right: 24px; */

    button:first-of-type {
      margin-right: 12px !important;
    }
  }

  .ant-row-flex {
    margin: 0;
  }

  .selectDiv {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      font-family: "Asap", sans-serif;
      font-size: 14px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
`;

export const Table = styled.table`
  width: 100% !important;
  min-width: 100% !important;
  margin-top: 10px;
  tbody {
    tr {
      background: #f5f5f5;
      td {
        padding-top: 10px;
        padding-bottom: 10px;
        font-family: Asap;
        font-weight: normal;
        font-size: 12px;

        color: #4b4b4b;

        &:first-child {
          text-align: left;
          padding-left: 15px;
        }
        &:last-child {
          width: 120px;
          padding-right: 15px;
          text-align: right;
        }

        span {
          font-family: Asap;
          font-weight: bold;
          font-size: 12px;
          text-align: center;
          color: #a5a5a5;
          display: flex;
          align-items: center;
          &.success {
            color: #41c36f;
          }
          svg {
            margin-right: 5px;
          }
        }

        div.buttonGroup {
          display: flex;
          align-items: flex-end;
        }

        button {
          border: none;
          background: transparent;
          font-family: Asap;
          font-weight: normal;
          font-size: 12px;
          display: flex;

          &.add {
            align-items: center;
            color: #4a85ae;
            svg {
              margin-left: 5px;
            }
          }

          &.edit {
            color: #9386aa;
            svg {
              margin-left: 5px;
              path {
                fill: #9386aa !important;
              }
            }
          }

          &:hover {
            cursor: pointer;
          }

          &.delete {
            color: #d44c4c;
            svg {
              margin-left: 0px;
              path {
                fill: #d44c4c !important;
              }
            }

            &:before {
              content: "|";
              color: #a5a5a5;
              margin-left: 10px;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
`;

export const SupplementInfoCard = styled.div`
  width: 100%;
  border-radius: 6px;
  background: transparent;
  border: 1px dashed #fe8d2a;
  margin-top: 13px;
  font-family: Asap;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
  color: #fe8d2a;
  text-align: center;
  padding: 8px;
  svg {
    margin-right: 30px;
    g {
      path {
        fill: #fe8d2a !important;
        color: #fe8d2a !important;
      }
    }
  }
`;

export const RadioGroupCustom = styled(Radio.Group)`
  &.ant-radio-group {
    width: 100%;
  }
`;

export const RadioButtonCustom = styled(Radio.Button)`
  margin-top: 6px !important;
  border-radius: 0 15px 15px 0 !important;
  // background: transparent !important;

  .ant-radio-group-solid.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #fff;
    background: #ffff !important;
    border-color: #ffff !important;
  }

  span {
    font-family: Asap !important;
    font-weight: normal !important;
    font-size: 14px !important;
    text-align: left !important;
    color: #684e94 !important;
  }

  &:first-of-type {
    margin-left: 0px;
    border-radius: 15px 0 0 15px !important;
    width: 35%;
  }

  &:not(:first-of-type) {
    margin-left: 0;
  }

  &.ant-radio-button-wrapper-disabled {
    border-color: #c4c4c4 !important;
    background-color: #c4c4c4 !important;
    span {
      color: #c4c4c4 !important;
    }
  }

  &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #fff;
    background: #684e94 !important;
    border-color: #684e94 !important;
  }

  &.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    color: #fff;
    background: #684e94 !important;
    border-color: #684e94 !important;
  }

  &.ant-radio-button-wrapper-checked {
    &:first-child,
    &:not(:first-child) {
      border-color: #9074bf !important;
    }
    color: #fff !important;
    background: #9074bf !important;
    border-color: #9074bf !important;

    &.ant-radio-button-wrapper-disabled {
      border-color: #c4c4c4 !important;
      background: #c4c4c4 !important;
    }

    span {
      font-family: Asap !important;
      font-weight: normal !important;
      font-size: 14px !important;
      text-align: left !important;
      color: #fff !important;
    }
  }
  &:not(:first-child)::before {
    visibility: hidden !important;
  }

  &.ant-radio-button-wrapper:last-child {
    width: 65%;
  }
`;

export const Bold = styled.span`
  font-weight: bold;
`;
